import { useState } from "react";
import { Button } from "./ui/button";

export const US_STATES = [
  "AL","AK","AZ","AR","CA","CO","CT","DC","DE","FL",
  "GA","HI","ID","IL","IN","IA","KS","KY","LA","ME",
  "MD","MA","MI","MN","MS","MO","MT","NE","NV","NH",
  "NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI",
  "SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY",
];

export default function StatesPicker({ value = [], onChange, testIdPrefix = "states", compact = false }) {
  const set = new Set(value);

  const toggle = (s) => {
    const next = new Set(set);
    if (next.has(s)) next.delete(s);
    else next.add(s);
    onChange(Array.from(next).sort());
  };

  return (
    <div data-testid={`${testIdPrefix}-picker`}>
      <div className="flex items-center justify-between mb-2">
        <div className="text-[11px] font-mono tracking-widest uppercase text-zinc-500">
          {value.length} selected
        </div>
        <div className="flex gap-1.5">
          <Button
            type="button"
            size="sm"
            variant="ghost"
            className="btn-sharp text-[10px] uppercase tracking-widest font-bold h-7"
            onClick={() => onChange([...US_STATES])}
            data-testid={`${testIdPrefix}-select-all`}
          >
            Select all
          </Button>
          <Button
            type="button"
            size="sm"
            variant="ghost"
            className="btn-sharp text-[10px] uppercase tracking-widest font-bold h-7"
            onClick={() => onChange([])}
            data-testid={`${testIdPrefix}-clear`}
          >
            Clear
          </Button>
        </div>
      </div>
      <div className={`grid ${compact ? "grid-cols-10" : "grid-cols-7 sm:grid-cols-10"} gap-1`}>
        {US_STATES.map((s) => {
          const on = set.has(s);
          return (
            <button
              type="button"
              key={s}
              onClick={() => toggle(s)}
              className={`btn-sharp border px-2 py-1.5 font-mono font-bold text-xs transition ${
                on
                  ? "bg-black text-white border-black"
                  : "bg-white text-zinc-700 border-zinc-300 hover:border-black"
              }`}
              data-testid={`${testIdPrefix}-state-${s}`}
            >
              {s}
            </button>
          );
        })}
      </div>
    </div>
  );
}
